/// <amd-module name="Dashboards/AddToDashboard/SimpleDashboardPicker" />
import * as React from "react";
import { VssComponent } from "VSS/Platform/Layout";
import { IPickListGroup, IPickListItem, IPickListSelection, PickListDropdown } from "VSSUI/PickList";
import { VssIconType } from "VSSUI/VssIcon";

import * as Resources from "Dashboards/AddToDashboard/Resources";
import { Dashboard } from "Dashboards/Common/Contracts/Dashboard";

export interface DashboardPickerItem extends Dashboard {
    /** If no group key is provided, it's assumed to be the owner ID. */
    groupKey?: string;

    displayName: string;
}

export interface SimpleDashboardPickerProps {
    dashboards: DashboardPickerItem[];

    groups: IPickListGroup[];

    selectedItem: DashboardPickerItem | undefined;
    onSelection: (dashboard: DashboardPickerItem) => void;
}

/** This panel is used to allow a user to select a Dashboard from the current project.
 *  Note for testing: The search box only appears if a minimum required number of elements appears.
 */
export class SimpleDashboardPicker extends VssComponent<SimpleDashboardPickerProps> {
    public render(): JSX.Element | null {
        return (
            <PickListDropdown
                className="dashboard-picker"
                getPickListItems={() => {
                    return this.props.dashboards;
                }}
                groups={this.props.groups}
                pickListClassName={"dashboard-item-picker-dropdown"}
                placeholder={Resources.SelectADashboard}
                getListItem={this.getListItem}
                onSelectionChanged={this.onSelectedItemChanged}
                selectedItems={this.props.selectedItem !== undefined ? [this.props.selectedItem] : undefined}
                searchTextPlaceholder={Resources.Search}
                isSearchable={true}
                searchNoResultsText={Resources.NoItems}
            />
        );
    }

    private onSelectedItemChanged = (selection: IPickListSelection<DashboardPickerItem>): void => {
        this.props.onSelection(selection.selectedItems && selection.selectedItems[0]);
    };

    private getListItem = (item: DashboardPickerItem) => {
        const groupKey = item.groupKey || item.ownerId;

        return {
            name: item.displayName,
            key: `${groupKey} - ${item.id}`,
            groupKey: groupKey,
            iconProps: {
                iconType: VssIconType.fabric,
                iconName: "ViewDashboard"
            }
        } as IPickListItem;
    };
}
